function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useRef, useState } from 'react';
import { Container, EntryAnimation } from '../../atoms';
import LegacySimulatorHeader from './LegacySimulatorHeader';
import StepRegion, { ELegacySimulatorRegion } from './StepContent/StepRegion';
import StepTotalAmount from './StepContent/StepTotalAmount';
import StepListBeneficiary from './StepContent/StepListBeneficiary';
import StepResult from './StepContent/StepResult';
export default function LegacySimulatorSection(param) {
    var t = param.t, data = param.data, className = param.className, handleSendEmail = param.handleSendEmail;
    var containerRef = useRef(null);
    var stepState = useState(1);
    var step = stepState[0];
    var regionState = useState(ELegacySimulatorRegion.FLANDRE);
    var amountState = useState(null);
    var beneficiariesState = useState([]);
    var duveAmountState = useState('');
    return /*#__PURE__*/ React.createElement(Container, {
        ref: containerRef,
        name: LegacySimulatorSection.name,
        className: className
    }, /*#__PURE__*/ React.createElement("div", {
        id: "legacySimulatorSection",
        className: "flex flex-col items-center justify-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full max-w-md text-left md:text-center"
    }, /*#__PURE__*/ React.createElement(EntryAnimation, {
        view: containerRef
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col w-full h-auto gap-5 px-4 py-8 rounded-3xl bg-subtle-700 md:px-8 lg:py-22 lg:px-22"
    }, /*#__PURE__*/ React.createElement(LegacySimulatorHeader, {
        data: _object_spread_props(_object_spread({}, data["step".concat(step)]), {
            stepIndex: step,
            region: regionState[0]
        }),
        t: t
    }), step === 1 && /*#__PURE__*/ React.createElement(StepRegion, {
        t: t,
        stepState: stepState,
        regionState: regionState
    }), step === 2 && /*#__PURE__*/ React.createElement(StepTotalAmount, {
        t: t,
        stepState: stepState,
        amountState: amountState
    }), step === 3 && /*#__PURE__*/ React.createElement(StepListBeneficiary, {
        t: t,
        stepState: stepState,
        beneficiariesState: beneficiariesState
    }), step === 4 && /*#__PURE__*/ React.createElement(StepResult, {
        t: t,
        stepState: stepState,
        beneficiariesState: beneficiariesState,
        duveAmountState: duveAmountState,
        region: regionState[0],
        amount: amountState[0] || 0,
        handleSendEmail: handleSendEmail
    }))))));
}

//# sourceMappingURL=LegacySimulatorSection.js.map